export const GROUP_POINTS_ALGORITHM = {
    LOGARITHM: 'LOGARITHM',
    LINEAR: 'LINEAR',
    AVERAGE: 'AVERAGE',
};

const ALGORITHM_NAME_KEYS = {
    [GROUP_POINTS_ALGORITHM.LOGARITHM]: 'my-company.groupPointsAlgorithm.logarithmName',
    [GROUP_POINTS_ALGORITHM.LINEAR]: 'my-company.groupPointsAlgorithm.linearName',
    [GROUP_POINTS_ALGORITHM.AVERAGE]: 'my-company.groupPointsAlgorithm.averageName',
};

const TEAM_POINTS_DESCRIPTION_KEYS = {
    [GROUP_POINTS_ALGORITHM.LINEAR]: 'rankingPage.teamPointsDescriptionLinear',
    [GROUP_POINTS_ALGORITHM.AVERAGE]: 'rankingPage.teamPointsDescriptionAverage',
};

const TEAM_POINTS_MEMBERS_DESCRIPTION_KEYS = {
    [GROUP_POINTS_ALGORITHM.LINEAR]: 'rankingPage.teamPointsMembersDescriptionLinear',
    [GROUP_POINTS_ALGORITHM.AVERAGE]: 'rankingPage.teamPointsMembersDescriptionAverage',
};

export const normalizeGroupPointsAlgorithm = (value) => {
    if (!value) {
        return GROUP_POINTS_ALGORITHM.LOGARITHM;
    }
    const normalized = String(value).trim().toUpperCase();
    return Object.values(GROUP_POINTS_ALGORITHM).includes(normalized)
        ? normalized
        : GROUP_POINTS_ALGORITHM.LOGARITHM;
};

export const getGroupPointsAlgorithmOptions = (t) => [
    {
        label: t('my-company.groupPointsAlgorithm.logarithm'),
        value: GROUP_POINTS_ALGORITHM.LOGARITHM,
    },
    {
        label: t('my-company.groupPointsAlgorithm.linear'),
        value: GROUP_POINTS_ALGORITHM.LINEAR,
    },
    {
        label: t('my-company.groupPointsAlgorithm.average'),
        value: GROUP_POINTS_ALGORITHM.AVERAGE,
    },
];

export const getGroupPointsAlgorithmName = (t, algorithm) =>
    t(ALGORITHM_NAME_KEYS[normalizeGroupPointsAlgorithm(algorithm)]);

export const getTeamPointsDescriptionKey = (algorithm) =>
    TEAM_POINTS_DESCRIPTION_KEYS[normalizeGroupPointsAlgorithm(algorithm)] || 'rankingPage.teamPointsDescription';

export const getTeamPointsMembersDescriptionKey = (algorithm) =>
    TEAM_POINTS_MEMBERS_DESCRIPTION_KEYS[normalizeGroupPointsAlgorithm(algorithm)] || 'rankingPage.teamPointsMembersDescription';

export const getTeamPointsInfoText = (t, algorithm) =>
    t('rankingPage.teamPointsActiveAlgorithm', {
        algorithm: getGroupPointsAlgorithmName(t, algorithm),
        description: t(getTeamPointsDescriptionKey(algorithm)),
    });

export const getTeamPointsMembersInfoText = (t, algorithm) =>
    t('rankingPage.teamPointsMembersActiveAlgorithm', {
        algorithm: getGroupPointsAlgorithmName(t, algorithm),
        description: t(getTeamPointsMembersDescriptionKey(algorithm)),
    });
